import { useFormatAmount } from '@capsicum/common';

import { useAvailableMarketsPaginatedQuery, useMainCurrenciesQuery } from '../../wallet';

export const useAvailableMarkets = (...props: Parameters<typeof useAvailableMarketsPaginatedQuery>) => {
	const { formatAmount } = useFormatAmount();
	const { data: currencies } = useMainCurrenciesQuery();
	const { altCurrency, defaultCurrency } = currencies ?? {};

	const {
		data: availableMarkets,
		fetchNextPage,
		hasNextPage,
		isFetching,
		isFetchingNextPage,
		isLoading
	} = useAvailableMarketsPaginatedQuery(...props);

	return {
		altCurrency,
		availableMarkets,
		defaultCurrency,
		fetchNextPage,
		formatAmount,
		hasNextPage,
		isFetching,
		isFetchingNextPage,
		isLoading
	};
};
